const $rand = (_obj, _expr, _options) => Math.random();
export {
  $rand
};
